import React from 'react';
import cn from 'classnames';

import { IFormikForgotFormProps } from './types';
import { FormLabel, Input } from '@infologistics/frontend-libraries';
import { LoginButtons } from '../Signin/components/LoginButtons';
import { AuthTranslations } from '@app/const/translations';
import { RouteName, UserField } from '@app/const/consts';
import { useTranslation } from 'react-i18next';
import styles from '../AuthNew.module.scss';
import { ICON_PROPS } from '../Signin/components/consts';
import { getErrorText, hasError } from '@app/utils/utils';

export const ForgotForm = (props: IFormikForgotFormProps) => {
  const { t } = useTranslation();
  const { isDisabled, handleSubmit, handleChange, errors, touched } = props;
  const { email } = props.values;

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className='mb-6'>
        <FormLabel htmlFor={UserField.EMAIL} text={t('common:email')} className={cn(styles.label, 'text-muted')} />
        <Input
          name={UserField.EMAIL}
          id={UserField.EMAIL}
          hasError={hasError(UserField.EMAIL, errors, touched)}
          errorText={t(getErrorText(UserField.EMAIL, errors))}
          required
          onChange={handleChange}
          value={email ?? ''}
          rightIcon='IconEnvelopSolid'
          rightIconProps={{ ...ICON_PROPS, classes: styles.input_icon }}
          inputSize='md'
          classes={{ wrapper: cn(styles.input), input: cn(styles.inputs, styles.input_radius) }}
        />
      </div>
      <LoginButtons
        isDisabled={isDisabled}
        main={{
          text: AuthTranslations.restore,
        }}
        left={{
          text: AuthTranslations.backToLogin,
          onLink: RouteName.SIGN_IN,
        }}
      />
    </form>
  );
};
